<template>
    <div>
        <VueTagsInput
            v-model="tag"
            :tags="tags"
            :disabled="disabled"
            @before-deleting-tag="beforeDeleteSource"
            @before-adding-tag="beforeAddingSource"
            @tags-changed="tagsChanged"
            :autocomplete-items="filteredItems"
            :placeholder="$t('firewall.addSource')">
            </VueTagsInput>
    </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'
// import { getAxios } from 'services/ajax'
export default {
    props: {
        rule: {
            required: true
        },
        disabled: {}
    },

    components: {
        VueTagsInput
    },

    computed: {
        filteredItems () {
            return this.autocompleteItems.filter(i => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
    },

    data () {
        return {
            tag: '',
            tags: [],
            autocompleteItems: [{
                text: 'All IPv4',
            }],
        }
    },

    mounted () {
        this.tags = this.rule.sources.map(source => {
            return {
                text: source.source,
                id: source.id
            }
        })
    },

    methods: {
        tagsChanged (tags) {
            this.$emit('input', tags.map(tag => {
                return {
                    source: tag.text,
                    id: tag.id
                }
            }))
        },

        beforeDeleteSource ({ deleteTag }) {
            deleteTag()
        },
        getIpRangeFromAddressAndNetmask(str) {
            let part = str.split("/"); 
            // part[0] = base address, part[1] = netmask
            let ipaddress = part[0].split('.');
            let netmaskblocks = ["0","0","0","0"];

            if(!/\d+\.\d+\.\d+\.\d+/.test(part[1])) {
                // part[1] has to be between 0 and 32
                netmaskblocks = ("1".repeat(parseInt(part[1], 10)) + "0".repeat(32-parseInt(part[1], 10))).match(/.{1,8}/g);
                netmaskblocks = netmaskblocks.map(function(el) { return parseInt(el, 2); });
            } else {
                // xxx.xxx.xxx.xxx
                netmaskblocks = part[1].split('.').map(function(el) { return parseInt(el, 10) });
            }// invert for creating broadcast address (highest address)
        var invertedNetmaskblocks = netmaskblocks.map(function(el) { return el ^ 255; });
        var baseAddress = ipaddress.map(function(block, idx) { return block & netmaskblocks[idx]; });
        var broadcastaddress = baseAddress.map(function(block, idx) { return block | invertedNetmaskblocks[idx]; });
        return [baseAddress.join('.'), broadcastaddress.join('.')];
        },
        beforeAddingSource ({ tag, addTag }) {
             const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))($|\/([0-9]|[12345][0-9]|6[0-4])$)/
            const ipv4Regex = /^((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])($|\/([0-9]|[12][0-9]|3[0-2])$)/
            const allValidIps = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
            let type = null;
            
            if (this.tags.find(t => t.text === tag.text)) {
                this.tag = ''
                return
            }


            if(tag.text.indexOf('/') > -1) {
                const [ ip, mask ] = tag.text.split('/')
                if(parseInt(mask) > 32 || parseInt(mask) < 0) {
                    this.$toasted.error(this.$t('firewall.invalidNetmask'))
                    return
                }

                // CIDR
                let range = this.getIpRangeFromAddressAndNetmask(tag.text);
                tag.text = range[0];
                
                if((type == 'ipv4' && ipv4Regex.test(tag.text)) || (type == 'ipv6' && ipv6Regex.test(tag.text)) || !type){
                    tag.text = range[0]+'/'+mask;
                    addTag({
                        text: tag.text,
                        id: tag.id
                    })
                    this.tag = 'subnet'
                } else {
                    this.$toasted.error(this.$t('firewall.invalidSource'))
                }
                return
                
            }
            
            for (var i in this.tags) {
                const storedTag = this.tags[i]

                if (storedTag.text === 'All IPv6' || storedTag.text === 'All IPv4') {
                    continue
                } else if ((!type || type == 'ipv4') && ipv4Regex.test(storedTag.text)) {
                    type = 'ipv4'
                } else if ((!type || type == 'ipv6') && ipv6Regex.test(storedTag.text)) {
                    type = 'ipv6'
                } else {
                    
                    this.showToast(this.$t('firewall.toast_cannot_mix_ipv4_ipv6'), {
                        icon: 'fa-times-o',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                    return
                }
            }

            if (allValidIps.test(tag.text))
            {
                if ((type == 'ipv4' && ipv4Regex.test(tag.text)) || (type == 'ipv6' && ipv6Regex.test(tag.text)) || !type) {
                    addTag()
                    this.tags.push(tag)
                } else if (/(^All IPv6$|^All IPv4$)/.test(tag.text)) {
                    addTag()
                    this.tags.push(tag)
                } else {
                    this.showToast(this.$t('firewall.toast_cannot_mix_ipv4_ipv6'), {
                        icon: 'fa-times-o',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                    return
                }
            }
            else
            {
                this.showToast(this.$t('firewall.toast_invalid_ip'), {
                        icon: 'fa-times-o',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                    return
            }

            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/firewalls/SourceTags.vue